<template>
  <div class="section">
    <Rgrid :gdata="gridData" :columns="gridColumns" :footer="gridfooter"></Rgrid>
    <router-view />
  </div>
</template>

<script>
import Rgrid from "../components/layout/Rgrid.vue";
// emojis: 🌏🙂😟😐🤨🏳️📛📅🗑️❌📑👈🔒💖

export default {
  name: "app",
  data() {
    return {
      gridData: [
        {Category: "API", SpecificItem: "World", URLReference: "https://covid19.mathdro.id/api"},
        {Category: "API", SpecificItem: "India", URLReference: "https:/i.covid19india.org/"},
        {Category: "Sidebar Menu", SpecificItem: "Sidebar Menu Concepts & Ideas", URLReference: "https://yaminncco.github.io/vue-sidebar-menu/#"},
        {Category: 'Icon: India', Image: "<img src='./../assets/india.png'/>", SpecificItem: "India small", URLReference: "Icons made by Freepik from www.flaticon.com"},
        {Category: 'Icon: Covid 19 Virus', Image: "<img src='./../assets/favicon-32x32.png'>", SpecificItem: "Favicon", URLReference: "Photo by CDC from <a href='https://www.pexels.com/photo/coronavirus-3992933/' rel='external'>Pexels "},
        {Category: "Responsive Table", SpecificItem: "Responsive Table Ideas", URLReference: "https://codepen.io/pixelchar/pen/rfuqK?editors=1100"}
      ],
      gridColumns: ["Category", "Image", "SpecificItem", "URLReference"],
      gridfooter: "Not forgetting the Innumerable, Unsung heroes in StackOverflow, Medium, DigitalOcean etc"
    };
  },
  components: {
    Rgrid
  },
  created() {
    document.title = `Covi9 19 Stats : ${this.$route.name}`;
  }
};
</script>
